export default "__VITE_ASSET__DoxMFG9m__"